import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { LoginMode } from '../../../ReduxStorage/Auth/Login/constants';
import { FontAwesome } from '../FontAwesome';

import './styles.scss';

export class LoginSignup extends React.PureComponent {
  static propTypes = {
    view: PropTypes.oneOf([
      LoginMode.login,
      LoginMode.signup,
      LoginMode.forgotPassword,
    ]).isRequired,
    onBackToLoginClick: PropTypes.func.isRequired,
    onSelectSignup: PropTypes.func.isRequired,
    onSelectLogin: PropTypes.func.isRequired,
    loginForm: PropTypes.node.isRequired,
    signUpForm: PropTypes.node.isRequired,
    resetPasswordForm: PropTypes.node.isRequired,
  };

  render() {
    const {
      view,
      onSelectSignup,
      onSelectLogin,
      onBackToLoginClick,
      loginForm,
      signUpForm,
      resetPasswordForm,
    } = this.props;
    return (
      <div className="login-signup">
        {view === LoginMode.forgotPassword ? (
          <>
            <div className="login-signup-top back-to-login">
              <button onClick={onBackToLoginClick} type="button">
                <FontAwesome name="arrow-circle-left" /> Back
              </button>
            </div>
            <div className="reset-password-panel">{resetPasswordForm}</div>
          </>
        ) : (
          <>
            <div className="login-signup-top login-tabs__tab-list">
              <div
                className={classNames('login-tab', {
                  selected: view === LoginMode.signup,
                })}
              >
                <button onClick={onSelectSignup} type="button">
                  Sign Up
                </button>
              </div>
              <div
                className={classNames('login-tab', {
                  selected: view === LoginMode.login,
                })}
              >
                <button onClick={onSelectLogin} type="button">
                  Log In
                </button>
              </div>
            </div>
            <div className="login-tabs__tab-panels">
              <div
                className={classNames({ selected: view === LoginMode.signup })}
              >
                {signUpForm}
              </div>
              <div
                className={classNames({ selected: view === LoginMode.login })}
              >
                {loginForm}
              </div>
            </div>
          </>
        )}
      </div>
    );
  }
}
